<template>
  <div>
    <creating
      v-if="creating" />
    <div
      v-if="!creating"
      style="position: relative">
      <vue-particles
        v-if="loading"
        style="width: 100%; height: 100%; position: absolute; z-index: 2"
        color="#000000"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#212529"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="5"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push" />
      <form
        :class="{'box-loading': loading}"
        v-on:submit.prevent="generate">
        <div class="form-group">
          <label>Idioma do job description</label><br>
          <select
            class="form-control"
            v-model="params.job_description_language">
            <option
              v-for="(item, index) in description_languages"
              :key="index"
              :value="item">{{ item }}</option>
          </select>
          <ValidateMessage :error="validateErrors.job_description_language" />
        </div>

        <div class="form-group">
          <label>Tom de escrita</label><br>
          <div
            v-for="(item, index) in job_description_tones"
            :key="index"
            class="form-check">
            <input
              class="form-check-input"
              type="radio"
              :value="item.name"
              v-model="params.job_description_tone"
              :id="`tone${index}`">
            <label
              class="form-check-label"
              :for="`tone${index}`">{{ item.name }}</label>
            <ValidateMessage :error="validateErrors.job_description_tone" />
            <p class="text-muted">{{ item.label }}</p>
          </div>
        </div>

        <hr class="my-4">

        <div class="form-group">
          <label for="cargo_vaga">Cargo</label>
          <input
            type="text"
            class="form-control"
            v-model="params.job_title">
          <ValidateMessage :error="validateErrors.job_title" />
        </div>

        <div class="form-section">
          <div>
            <input
              id="experience_level"
              type="checkbox"
              v-model="enable.experience_level" />
          </div>
          <div :class="{ 'disabled1': !enable.experience_level }">
            <div class="form-group">
              <label for="experience_level">Nível de experiência</label><br>
              <div class="check-cols">
                <div
                  v-for="(item, index) in experienceLevels"
                  :key="index"
                  class="form-check"> <!--form-check-inline-->
                  <input
                    class="form-check-input"
                    type="radio"
                    :value="item"
                    v-model="params.experience_level"
                    :id="`experience_level${index}`"
                    :disabled="!enable.experience_level">
                  <label
                    class="form-check-label"
                    :for="`experience_level${index}`">{{ item }}</label>
                </div>
              </div>
              <ValidateMessage :error="validateErrors.experience_level" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <div>
            <input
              id="type_work"  
              type="checkbox"
              v-model="enable.type_work" />
          </div>
          <div :class="{ 'disabled1': !enable.type_work }">
            <div class="form-group">
              <label for="type_work">Modalidade de trabalho</label><br>
              <div class="check-cols">
                <div
                  v-for="(item, index) in types_work"
                  :key="index"
                  class="form-check"> <!--form-check-inline-->
                  <input
                    class="form-check-input"
                    type="radio"
                    :value="item"
                    v-model="params.type_work"
                    :id="`type_work${index}`"
                    :disabled="!enable.type_work">
                  <label
                    class="form-check-label"
                    :for="`type_work${index}`">{{ item }}</label>
                </div>
              </div>
              <ValidateMessage :error="validateErrors.type_work" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <div>
            <input
              id="contract_type"
              type="checkbox"
              v-model="enable.contract_type" />
          </div>
          <div :class="{ 'disabled1': !enable.contract_type }">
            <div class="form-group">
              <label for="contract_type">Tipo de contrato</label>
              <div class="check-cols">
                <div
                  v-for="(item, index) in contract_types"
                  :key="index"
                  class="form-check"> <!--form-check-inline-->
                  <input
                    class="form-check-input"
                    type="radio"
                    :value="item"
                    v-model="params.contract_type"
                    :id="`contract_type${index}`"
                    :disabled="!enable.contract_type">
                  <label
                    class="form-check-label"
                    :for="`contract_type${index}`">{{ item }}</label>
                </div>
              </div>
              <ValidateMessage :error="validateErrors.contract_types" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <div>
            <input
              id="languages"
              type="checkbox"
              v-model="enable.languages" />
          </div>
          <div :class="{ 'disabled1': !enable.languages }">
            <div class="form-group">
              <label for="languages">Idiomas requeridos</label><br>
              <div class="check-cols">
                <div v-for="(item, index) in resources.language" :key="index" class="form-check"> <!--form-check-inline-->
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :value="item.name"
                    v-model="params.languages"
                    :id="`languages${index}`"
                    :disabled="!enable.languages">
                  <label class="form-check-label" :for="`languages${index}`">{{ item.name }}</label>
                </div>
              </div>
              <ValidateMessage :error="validateErrors.languages" />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>{{ $t('Attributions') }}</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.assignments" :value="false" id="enable_assignments1">
              <label class="form-check-label" for="enable_assignments1">Automático</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.assignments" :value="true" id="enable_assignments2">
              <label class="form-check-label" for="enable_assignments2">Definir</label>
            </div>
          </div>
          <textarea-autosize
            v-if="enable.assignments"
            :placeholder="$t('Especifique as atribuições separadas por vírgula.')"
            v-model="params.assignments"
            :min-height="30"
            :max-height="1000"
            class="form-control mt-2">
            </textarea-autosize>
          <ValidateMessage :error="validateErrors.assignments" />
        </div>

        <div class="form-group">
          <label>Habilidades técnicas</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.technical_skills" :value="false" id="enable_technical_skills1">
              <label class="form-check-label" for="enable_technical_skills1">Automático</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.technical_skills" :value="true" id="enable_technical_skills2">
              <label class="form-check-label" for="enable_technical_skills2">Definir</label>
            </div>
          </div>
          <textarea-autosize
            v-if="enable.technical_skills"
            :placeholder="$t('Especifique as atribuições separadas por vírgula.')"
            v-model="params.technical_skills"
            :min-height="30"
            :max-height="1000"
            class="form-control mt-2">
            </textarea-autosize>
          <ValidateMessage :error="validateErrors.technical_skills" />
        </div>

        <div class="form-group">
          <label>Soft Skills</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.soft_skills" :value="false" id="enable_soft_skills1">
              <label class="form-check-label" for="enable_soft_skills1">Automático</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.soft_skills" :value="true" id="enable_soft_skills2">
              <label class="form-check-label" for="enable_soft_skills2">Definir</label>
            </div>
          </div>
          <textarea-autosize
            v-if="enable.soft_skills"
            :placeholder="$t('Especifique as atribuições separadas por vírgula.')"
            v-model="params.soft_skills"
            :min-height="30"
            :max-height="1000"
            class="form-control mt-2">
            </textarea-autosize>
          <ValidateMessage :error="validateErrors.soft_skills" />
        </div>

        <div class="form-group">
          <label>Benefícios</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.benefits" :value="false" id="enable_benefits1">
              <label class="form-check-label" for="enable_benefits1">Automático</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="enable.benefits" :value="true" id="enable_benefits2">
              <label class="form-check-label" for="enable_benefits2">Definir</label>
            </div>
          </div>
          <textarea-autosize
            v-if="enable.benefits"
            :placeholder="$t('Especifique as atribuições separadas por vírgula.')"
            v-model="params.benefits"
            :min-height="30"
            :max-height="1000"
            class="form-control mt-2">
            </textarea-autosize>
          <ValidateMessage :error="validateErrors.benefits" />
        </div>

        <hr class="my-4">

        <h5 class="mb-3">Sobre a Empresa</h5>
        <div class="form-section">
          <div>
            <input
              id="company_name"
              type="checkbox"
              v-model="enable.company_name" />
          </div>
          <div :class="{ 'disabled1': !enable.company_name }">
            <div class="form-group">
              <label
                for="company_name">Nome da Empresa</label><br>
              <input
                type="text"
                class="form-control"
                v-model="params.company_name"
                :disabled="!enable.company_name">
              <ValidateMessage :error="validateErrors.company_name" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <div>
            <input
              id="company_sector"
              type="checkbox"
              v-model="enable.company_sector" />
          </div>
          <div :class="{ 'disabled1': !enable.company_sector }">
            <div class="form-group">
              <label
                for="company_sector">Setor da Empresa</label><br>
              <v-select
                v-model="params.company_sector"
                :taggable="true"
                :options="company_sectors"
                :disabled="!enable.company_sector">
                </v-select>
              <ValidateMessage :error="validateErrors.company_sector" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <div>
            <input
              id="company_size"
              type="checkbox"
              v-model="enable.company_size" />
          </div>
          <div :class="{ 'disabled1': !enable.company_size }">
            <div class="form-group">
              <label for="company_size">Tamanho da Empresa</label><br>
              <v-select
                v-model="params.company_size"
                :taggable="true"
                :options="company_sizes"
                :disabled="!enable.company_size">
                </v-select>
                <ValidateMessage :error="validateErrors.company_size" />
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-primary">Gerar</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobForm',
  components: {
  },
  props: {
    'value': {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    const locale = this.$store.getters.getMe.locale
    const jobDescriptionLanguage = {
      'en-US': 'English',
      'pt-BR': 'Português',
      'es-ES': 'Español'
    }[locale]

    return {
      creating: true,
      loading: true,
      description_languages: [
        'English',
        'Português',
        'Español'
      ],
      company_sectors: [
        'Agricultura, Pesca e Pecuária',
        'Alimentos e Bebidas',
        'Arte, Entretenimento e Mídia',
        'Automotivo',
        'Beleza e Cuidados Pessoais',
        'Biotecnologia e Farmacêutico',
        'Construção e Engenharia',
        'Consultoria',
        'Educação e Ensino',
        'Energia e Recursos Naturais',
        'Finanças e Seguros',
        'Governo e Organizações Públicas',
        'Hotelaria e Turismo',
        'Imobiliário',
        'Logística e Transporte',
        'Manufatura e Produção',
        'Marketing e Publicidade',
        'Moda e Vestuário',
        'Saúde e Bem-Estar',
        'Serviços Profissionais',
        'Software e Tecnologia',
        'Telecomunicações',
        'Varejo e Comércio'
      ],
      company_sizes: [
        'Startup',
        'Pequena Empresa',
        'Média Empresa',
        'Grande Empresa'
      ],
      types_work: [
        'Presencial',
        'Remoto',
        'Híbrido'
      ],
      contract_types: [
      ],
      job_description_tones: [
        { name: 'Conversacional', label: 'Pode ser adequado para posições de atendimento ao cliente, vendas, ou outras posições que envolvam muita interação.' },
        { name: 'Formal', label: 'Ideal para posições sênior, cargos de liderança, ou indústrias que valorizam a formalidade.' },
        { name: 'Descontraído com emojis', label: 'Pode ser atraente para startups ou empresas com uma cultura de trabalho mais casual.' },
        { name: 'Criativo', label: 'Pode ser adequado para cargos em marketing, design, publicidade, ou outras posições criativas.' }
      ],
      validateErrors: {},
      enable: {
        job_description_tone: true,
        job_description_language: true,
        job_title: true,
        experience_level: false,
        type_work: false,
        assignments: false,
        technical_skills: false,
        soft_skills: false,
        contract_type: Boolean(this.value.contract_id),
        languages: false,
        benefits: false,
        company_name: false,
        company_sector: false,
        company_size: false
      },
      params: {
        job_description_language: jobDescriptionLanguage,
        job_description_tone: 'Conversacional',
        job_title: this.value.title,
        experience_level: null,
        type_work: this.value._id ? {'remote': 'Remoto', 'hybrid': 'Híbrido', 'on-site': 'Presencial'}[this.value.workplace_type] : null,
        assignments: null,
        technical_skills: null,
        soft_skills: null,
        contract_type: this.value.contract_id,
        languages: [],
        benefits: null,
        company_name: null,
        company_sector: null,
        company_size: null
      }
    }
  },
  computed: {
    resources () {
      return this.$store.getters.getResources
    },
    experienceLevels () {
      return this.resources.experience_level.map(item => item.name)
    },
    me () {
      return this.$store.getters.getMe
    },
    locale () {
      return this.me.locale
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      const jobExperienceLevel = this.value.experience_level
      const jobContractId = this.value.contract_id && this.value.contract_id._id ? this.value.contract_id._id : this.value.contract_id

      return Promise.all([
        this.$store.dispatch('getContracts', { sort: 'name', limit: 2000 })
      ]).then(([contracts]) => {
        // contract_types
        this.contract_types = contracts.map(item => item.name)
        if (jobContractId) {
          const findContract = contracts.find(item => item._id === jobContractId)
          if (findContract) {
            this.enable.contract_type = true
            this.params.contract_type = findContract.name
          }
        }
        // experienceLevel
        if (jobExperienceLevel) {
          const experienceLevel = this.resources.experience_level.find(item => item.key === this.value.experience_level)
          if (experienceLevel) {
            this.enable.experience_level = true
            this.params.experience_level = experienceLevel.name
          }
        }
        this.creating = this.loading = false
      })
    },
    cancel () {
      this.$emit('cancel')
    },
    generate () {
      const params = {
        job_id: this.value._id
      }
      console.log({ params })
      Object.entries(this.params).forEach(([key, value]) => {
        if (this.enable[key] && value) {
          params[key] = value
        }
      })

      this.loading = true
      return this.axios.post('/accounts/' + this.$store.getters.getAccount._id + '/magic-gpt/job-description', params).then(response => {
        this.$emit('input', response.data)
      }).catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.check-cols {
  display: flex;
  flex-wrap: wrap;
}

.check-cols>* {
  flex: 1 160px;
}

.form-section {
  display: flex;
}

.form-section>*:nth-child(1) {
  padding: 2px 5px 0 0;
}

.form-section>*:nth-child(2) {
  flex: 1;
}

.disabled1 {
  opacity: 0.5;
}

.video-container {
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: calc(200px / 2);
  margin: 30px auto;
}
  .video-container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(1);
  }
</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobModalDescriptionForm.vue